import React, { ReactElement, ReactNode } from 'react'

export function separateArrayElements<Item extends any, Separator extends ReactElement | string>(
  separator: Separator,
  array: Item[],
  jsxMode: true
): (ReactNode | Item)[]

export function separateArrayElements<Item extends any, Separator extends string | number>(
  separator: Separator,
  array: Item[],
  jsxMode?: false
): (Separator | Item)[]

export function separateArrayElements<Item extends any, Separator>(
  separator: Separator,
  array: Item[],
  jsxMode?: boolean
): (ReactNode | Separator | Item)[] {
  return array
    .flatMap((element, index) => {
      if (jsxMode) {
        // to prevent React warning about missing key prop
        const separatorNode: ReactNode = <React.Fragment key={index}>{separator}</React.Fragment>
        return [separatorNode, element]
      }

      return [separator, element]
    })
    .slice(1)
}
